import React, { Component } from 'react';

//import './App.css';


export class MiniCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
			archetype: this.props.cardTitle,
			archetypeName: this.props.archetypeName,
      chosen: "no",
      titleBackground: "notSelectedText CardText",
      cardRarity: this.props.rarity + " MiniNotSelected",
			tab: this.props.tab,
			name: this.props.cardName,
			cardInputIndicator: ""
    };

  }

	componentDidMount(){


		document.querySelectorAll(".cardSettingLabel").forEach(function(rd){
			rd.addEventListener("mousedown", function(){
				if (this.checked) {
					this.onclick=function(){
						this.checked=false;
					}
				} else {
					this.onclick=null;
				}
			})
		});
	}


	toggleRadio(event) {
		let name = event.target.getAttribute("name");
		let attribute = event.target.getAttribute("tab");
		//let attribute = document.mainForm.getAttribute("name").getAttribute("tab");

		//let rarity = event.target.getAttribute("rarity");
		let cardRadio = name + "." + attribute;
		let tabbedChoice = document.mainForm[cardRadio];
		if (!tabbedChoice.checked) {
			tabbedChoice.checked = true;

			this.setState({
				cardRarity: "mini MiniSelected",
				cardInputIndicator: this.props.tab + "Indicator"
			});

		} else {
			var choice = document.mainForm[name];
			for (let i = 0; i < choice.length; i++) {
				if ( choice[i].checked === true ) {
					choice[i].checked = false;

					this.setState({
						cardRarity: "mini MiniNotSelected",
						cardInputIndicator: "noIndicator"
					});

				}
			}
		}


	}

  toggleChosen() {
    var isChosen = this.state.chosen === "yes" ? "no" : "yes";
    this.setState({ chosen: isChosen });

    if (isChosen === "yes") {
      this.setState({
        titleBackground: this.props.titleBackground + " CardText",
        cardRarity: this.props.rarity  + " MiniSelected"
      });
    } else {
      this.setState({
        titleBackground: "notSelectedText CardText",
        cardRarity: this.props.rarity + " MiniNotSelected"
      });
    }
  }


  render() {

    return (
      <div 	className={ "MiniCard " + this.props.cardName + " " + this.state.cardRarity }
						onClick={ this.toggleRadio.bind(this) }
						tab={ this.props.tab }
						rarity={ this.props.rarity }
						name={ this.state.name }
						/*onClick={ this.toggleChosen.bind(this) }*/>

        {/*<img src={require(`../images/${this.props.cardName.toLowerCase()}.png`)} className={ "MiniCard " + this.props.rarity + ' ' + this.props.cardName }/>*/}
				<input 	type="radio"
								name={ this.props.cardName }
								value={ this.props.cardName + ".war"}
								id={ this.props.cardName + ".war"} />
				<input 	type="radio"
								name={ this.props.cardName }
								value={ this.props.cardName + ".require"}
								id={ this.props.cardName + ".require"} />
				<input 	type="radio"
								name={ this.props.cardName }
								value={ this.props.cardName + ".suggest"}
								id={ this.props.cardName + ".suggest"}/>
				<input 	type="radio"
								name={ this.props.cardName }
								value={ this.props.cardName + ".ban"}
								id={ this.props.cardName + ".ban"}/>

				{/*<label htmlFor={ this.props.cardName + ".require"} onClick={ this.toggleRadio.bind(this.state.name) }>
					<div className={ "requireLabel cardSettingLabel" }/>
				</label>*/}

				{/*<label htmlFor={ this.props.cardName + ".suggest"} onClick={ this.toggleRadio.bind(this.state.name) }>
					<div className={ "requireLabel cardSettingLabel" }/>
				</label>*/}
				<div 	className={ "cardInputIndicator " + this.state.cardInputIndicator }
							/>
      </div>
    )
  }
}

export default MiniCard;



// WEBPACK FOOTER //
// ./src/Components/MiniCard.js